// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'neontubes';
  src: url('https://bitbucket.org/kennethjensen/webfonts/raw/fc13c1cb430a0e9462da56fe3f421ff7af72db71/neontubes/neontubes-webfont.eot');
  src: url('https://bitbucket.org/kennethjensen/webfonts/raw/fc13c1cb430a0e9462da56fe3f421ff7af72db71/neontubes/neontubes-webfont.eot?#iefix')
      format('embedded-opentype'),
    url('https://bitbucket.org/kennethjensen/webfonts/raw/fc13c1cb430a0e9462da56fe3f421ff7af72db71/neontubes/neontubes-webfont.woff2')
      format('woff2'),
    url('https://bitbucket.org/kennethjensen/webfonts/raw/fc13c1cb430a0e9462da56fe3f421ff7af72db71/neontubes/neontubes-webfont.woff')
      format('woff'),
    url('https://bitbucket.org/kennethjensen/webfonts/raw/fc13c1cb430a0e9462da56fe3f421ff7af72db71/neontubes/neontubes-webfont.ttf')
      format('truetype');
}

:root {
  --neon-text-color: rgb(255, 0, 0);
}

.beta {
  font-size: 30px;
  font-family: 'neontubes';
  font-weight: 100;
  color: #fff;
  transform: rotate(30deg);
  position: absolute;
  right: 10px;
  top: 20px;
  text-transform: uppercase;
  animation: flicker 1.5s infinite alternate;
}

.beta::-moz-selection {
  background-color: var(--neon-border-color);
  color: var(--neon-text-color);
}

.beta::selection {
  background-color: var(--neon-border-color);
  color: var(--neon-text-color);
}

.beta:focus {
  outline: none;
}

/* Animate neon flicker */
@keyframes flicker {
  0%,
  19%,
  21%,
  23%,
  25%,
  54%,
  56%,
  100% {
    text-shadow: -0.2rem -0.2rem 1rem #fff, 0.2rem 0.2rem 1rem #fff,
      0 0 2rem var(--neon-text-color), 0 0 4rem var(--neon-text-color),
      0 0 6rem var(--neon-text-color), 0 0 8rem var(--neon-text-color),
      0 0 10rem var(--neon-text-color);

    box-shadow: 0 0 0.5rem #fff, inset 0 0 0.5rem #fff,
      0 0 2rem var(--neon-border-color), inset 0 0 2rem var(--neon-border-color),
      0 0 4rem var(--neon-border-color), inset 0 0 4rem var(--neon-border-color);
  }

  20%,
  24%,
  55% {
    text-shadow: none;
    box-shadow: none;
  }
}
`, "",{"version":3,"sources":["webpack://./client/features/footer/beta.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,qIAAqI;EACrI;;;;;;;wBAOsB;AACxB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,WAAW;EACX,wBAAwB;EACxB,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;EAC1C,6BAA6B;AAC/B;;AAEA;EACE,0CAA0C;EAC1C,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA,yBAAyB;AACzB;EACE;;;;;;;;IAQE;;;sCAGkC;;IAElC;;gFAE4E;EAC9E;;EAEA;;;IAGE,iBAAiB;IACjB,gBAAgB;EAClB;AACF","sourcesContent":["@font-face {\r\n  font-family: 'neontubes';\r\n  src: url('https://bitbucket.org/kennethjensen/webfonts/raw/fc13c1cb430a0e9462da56fe3f421ff7af72db71/neontubes/neontubes-webfont.eot');\r\n  src: url('https://bitbucket.org/kennethjensen/webfonts/raw/fc13c1cb430a0e9462da56fe3f421ff7af72db71/neontubes/neontubes-webfont.eot?#iefix')\r\n      format('embedded-opentype'),\r\n    url('https://bitbucket.org/kennethjensen/webfonts/raw/fc13c1cb430a0e9462da56fe3f421ff7af72db71/neontubes/neontubes-webfont.woff2')\r\n      format('woff2'),\r\n    url('https://bitbucket.org/kennethjensen/webfonts/raw/fc13c1cb430a0e9462da56fe3f421ff7af72db71/neontubes/neontubes-webfont.woff')\r\n      format('woff'),\r\n    url('https://bitbucket.org/kennethjensen/webfonts/raw/fc13c1cb430a0e9462da56fe3f421ff7af72db71/neontubes/neontubes-webfont.ttf')\r\n      format('truetype');\r\n}\r\n\r\n:root {\r\n  --neon-text-color: rgb(255, 0, 0);\r\n}\r\n\r\n.beta {\r\n  font-size: 30px;\r\n  font-family: 'neontubes';\r\n  font-weight: 100;\r\n  color: #fff;\r\n  transform: rotate(30deg);\r\n  position: absolute;\r\n  right: 10px;\r\n  top: 20px;\r\n  text-transform: uppercase;\r\n  animation: flicker 1.5s infinite alternate;\r\n}\r\n\r\n.beta::-moz-selection {\r\n  background-color: var(--neon-border-color);\r\n  color: var(--neon-text-color);\r\n}\r\n\r\n.beta::selection {\r\n  background-color: var(--neon-border-color);\r\n  color: var(--neon-text-color);\r\n}\r\n\r\n.beta:focus {\r\n  outline: none;\r\n}\r\n\r\n/* Animate neon flicker */\r\n@keyframes flicker {\r\n  0%,\r\n  19%,\r\n  21%,\r\n  23%,\r\n  25%,\r\n  54%,\r\n  56%,\r\n  100% {\r\n    text-shadow: -0.2rem -0.2rem 1rem #fff, 0.2rem 0.2rem 1rem #fff,\r\n      0 0 2rem var(--neon-text-color), 0 0 4rem var(--neon-text-color),\r\n      0 0 6rem var(--neon-text-color), 0 0 8rem var(--neon-text-color),\r\n      0 0 10rem var(--neon-text-color);\r\n\r\n    box-shadow: 0 0 0.5rem #fff, inset 0 0 0.5rem #fff,\r\n      0 0 2rem var(--neon-border-color), inset 0 0 2rem var(--neon-border-color),\r\n      0 0 4rem var(--neon-border-color), inset 0 0 4rem var(--neon-border-color);\r\n  }\r\n\r\n  20%,\r\n  24%,\r\n  55% {\r\n    text-shadow: none;\r\n    box-shadow: none;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
